import { Apis } from "libs/apis";
import React from "react";
import { ResetDTO } from "utils/helpers/models/reset.dto";

export default function useForget() {
  const forget = async (body: ResetDTO) => {
    try {
      const res = await Apis.forget(body);
      return res.data;
    } catch (error: any) {
      return {
        success: false,
        message: error?.response?.data?.message || "Something went wrong",
        status: error?.response?.status || 500,
      };
    }
  };

  return { forget };
}
